import type { Doc } from "~/shared/types";
import { useDataStore } from "~/stores";
import { getPageDisplayName } from "~/utils/common";
import { makeFolderComparator } from "~/utils/comparator";

import type { Actions } from "..";

export default (_actions: Actions) => ({
  /**
   * Group and sort docs by folder with optional current folder prioritization
   */
  groupAndSortDocsByFolder: (docs: Doc[], currentFolderDuid?: string | null) => {
    const dataStore = useDataStore();

    const grouped = Object.groupBy(docs, (doc) => {
      const folder = dataStore.getFolderByDuid(doc.folderDuid);
      const space = folder ? dataStore.getSpaceByDuid(folder.spaceDuid) : null;
      const folderDisplayName = getPageDisplayName(folder, dataStore.getSpaceByDuid);

      if (space && folderDisplayName) {
        return `${space.abrev} / ${folderDisplayName}`;
      }
      return folderDisplayName || "Folder";
    }) as Record<string, Doc[]>;

    const sortedEntries = Object.entries(grouped).sort(([, docsA], [, docsB]) => {
      const folderA = dataStore.getFolderByDuid(docsA[0]?.folderDuid);
      const folderB = dataStore.getFolderByDuid(docsB[0]?.folderDuid);

      // If we have a current folder, prioritize it
      if (currentFolderDuid) {
        if (folderA?.duid === currentFolderDuid && folderB?.duid !== currentFolderDuid) {
          return -1;
        }
        if (folderB?.duid === currentFolderDuid && folderA?.duid !== currentFolderDuid) {
          return 1;
        }
      }

      return makeFolderComparator(dataStore.getSpaceByDuid)(folderA, folderB);
    });

    return sortedEntries;
  },
});
